import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'yes-no-modal',
  templateUrl: 'yes-no-modal.component.html',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule]
})
export class YesNoModal {
  private dialogRef = inject<MatDialogRef<YesNoModal>>(MatDialogRef);
  private data = inject(MAT_DIALOG_DATA);
  
  protected headerTitle = this.data.headerTitle;
  protected message = this.data.message;
  protected yesText = this.data.yesText;
  protected noText = this.data.noText;
  protected setNoButtonAsDefault = this.data.setNoButtonAsDefault ?? false;

  onYesClick() {
    this.dialogRef.close(true);
  }

  onNoClick() {
    this.dialogRef.close(false);
  }
}
